import React, { Component } from 'react'
import PropTypes from 'prop-types'

import classnames from 'classnames'

class RiderSharing extends Component {
  constructor(props) {
    super(props)

    this.state = {
      showDropdown: false
    }
  }

  renderDropdown(share) {
    const { showDropdown } = this.state

    const className = classnames({
      'ui-dropdown': true,
      'ui-dropdown--active': showDropdown
    })

    return (
      <div className={className}>
        {showDropdown === true ? <div className="ui-dropdown-escape" onClick={() => this.setState({showDropdown: !showDropdown})} /> : null}

        {
          showDropdown === true
          ? <ul className="ui-dropdown-content">
              <li onClick={() => this.setState({showDropdown: false}, () => this.props.removeRiderShare(share.email))}>Remove share</li>
            </ul>
          : null
        }
      </div>
    )
  }

  render() {
    const { share } = this.props

    return (
      <li>
        <div className="collaborator" data-name={share.email} onClick={() => this.setState({showDropdown: true})}>{share.email.substring(0, 2)}</div>

        {this.renderDropdown(share)}
      </li>
    )
  }
}

RiderSharing.propTypes = {
  share: PropTypes.object,
  removeRiderShare: PropTypes.func
}

RiderSharing.defaultProps = {
  share: {},
  removeRiderShare: function() {}
}

export default RiderSharing



// WEBPACK FOOTER //
// ./src/components/rider/rider-sharing/share.js